import { useFetchAdminIssueReportList } from '@api';
import {
  CategorySelectEnum,
  FromPageQueryParamValueEnum,
  PathnameEnum,
  PathParamKeyEnum,
  QueryParamKeyEnum
} from '@constant';
import { IAdminIssueReportListItem } from '@types';
import { useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

export const useIssueReport = () => {
  const [isIssueReportModalVisible, setIsIssueReportModalVisible] = useState<boolean>(false);

  const tableHeader = [
    { id: 'idLeft', label: 'ID', width: 73 },
    { id: 'fileNameLeft', label: '파일명', width: 363.5 },
    { id: 'reportContentLeft', label: '리포트 내용', width: 363.5 },
    { id: 'idRight', label: 'ID', width: 73 },
    { id: 'fileNameRight', label: '파일명', width: 363.5 },
    { id: 'reportContentRight', label: '리포트 내용', width: 363.5 }
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search); // location.search는 '?key=value' 형태
  const locationPathname = location.pathname;
  const isOpenIssueReportListPage = locationPathname === PathnameEnum.ADMIN_OPEN_ISSUE_REPORT_LIST; // true일 시 '접수된 오류' 페이지, false일 시 '처리 완료' 페이지
  const isResolvedIssueReportListPage = locationPathname === PathnameEnum.ADMIN_RESOLVED_ISSUE_REPORT_LIST;

  const [searchParams] = useSearchParams();
  const page = searchParams.get(QueryParamKeyEnum.PAGE) ? Number(searchParams.get(QueryParamKeyEnum.PAGE)) : 1;

  const { response } = useFetchAdminIssueReportList(
    page,
    isOpenIssueReportListPage ? 'open' : isResolvedIssueReportListPage ? 'resolved' : undefined
  );

  // 접수된 오류 및 처리 완료 페이지 좌우 컬럼에 보여줄 데이터 분리
  const splitData = (data: IAdminIssueReportListItem[]) => {
    const leftPaneData: IAdminIssueReportListItem[] = [];
    const rightPaneData: IAdminIssueReportListItem[] = [];
    data.forEach((row, idx) => (idx % 2 === 0 ? leftPaneData.push(row) : rightPaneData.push(row)));

    return { leftPaneData: leftPaneData, rightPaneData: rightPaneData };
  };

  const handleTableRowClick = (theme: string, imageId: number, sequenceId: number | null) => {
    if (isOpenIssueReportListPage) {
      queryParams.set(QueryParamKeyEnum.FROM_PAGE, FromPageQueryParamValueEnum.OPEN_ISSUE_REPORT_LIST);
    } else if (isResolvedIssueReportListPage) {
      queryParams.set(QueryParamKeyEnum.FROM_PAGE, FromPageQueryParamValueEnum.RESOLVED_ISSUE_REPORT_LIST);
    }

    if (theme === 'STANDARD') {
      queryParams.set(QueryParamKeyEnum.THEME, CategorySelectEnum.STANDARD);
    } else if (theme === 'ADULTS_ONLY') {
      queryParams.set(QueryParamKeyEnum.THEME, CategorySelectEnum.ADULTS_ONLY);
    }

    if (sequenceId) {
      queryParams.set(QueryParamKeyEnum.SEQUENCE_ID, String(sequenceId));
    }

    const queryString = queryParams.toString();

    navigate(
      `${PathnameEnum.ADMIN_IMAGE_EDIT_PAGE.replace(PathParamKeyEnum.IMAGE_ID, String(imageId))}?${queryString}`
    );
  };

  const handlePageChange = (value: number) => {
    queryParams.set(QueryParamKeyEnum.PAGE, String(value));
    const queryString = queryParams.toString();
    navigate(`${locationPathname}?${queryString}`, { replace: true });
  };

  return {
    isIssueReportModalVisible,
    setIsIssueReportModalVisible,

    handleTableRowClick,
    isOpenIssueReportListPage,
    tableHeader,
    response,
    splitData,
    page,
    handlePageChange
  };
};
